import React, { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { MoreVert } from '@mui/icons-material';

//translation
import { useTranslation } from 'react-i18next';

const UserTableActions = (props) => {
    const { row, openModal, openDeleteModal } = props;

    // state
    const [anchor, setAnchor] = useState(null);

    //transaltion
    const { t } = useTranslation('user');

    // functions
    const openMenu = (e) => setAnchor(e.target);
    const closeMenu = () => setAnchor(null);
    const openEditModal = () => {
        const payload = {
            email: row?.user_detail.email,
            role: row?.role,
            id: row?.id,
            routes: row?.routes?.split(','),
            support_user: row?.id,
            auditor_standards: row?.auditor_standards?.split(','),
            active_standards: row?.active_standards?.split(','),
            first_name: row?.user_detail.first_name,
        };
        openModal('edit', payload);
        closeMenu();
    };
    const handleOpenDeleteModal = () => {
        closeMenu();
        openDeleteModal(row);
    };

    return (
        <>
            <MoreVert className="rotate-90 cursor-pointer" onClick={openMenu} sx={{ color: '#64748B' }} />
            <Menu className="shadow-[none]" open={Boolean(anchor)} anchorEl={anchor} onClose={closeMenu}>
                <MenuItem className="!text-sm text-[#64748b] border-b border-[#F1F5F9]" onClick={openEditModal}>
                    {t('table.tableAction.edit')}
                </MenuItem>
                <MenuItem className="!text-sm !text-[#FF5449]" onClick={handleOpenDeleteModal}>
                    {t('table.tableAction.delete')}
                </MenuItem>
            </Menu>
        </>
    );
};

export default UserTableActions;
